module.exports = __webpack_public_path__ + "img/neurone-synthesis.14f2e1b5.gif";